import AboutArea from "@/components/publicWebsite/about/aboutArea";
import ContactArea from "@/components/publicWebsite/contact/contactArea";
import PageHeader from "@/components/publicWebsite/common/pageHeader";
import TeamArea from "@/components/publicWebsite/about/teamArea";
import { teamData } from "@/db/teamData";

export default function About() {  

  return (
    <>
      <PageHeader title="About Us" image="/images/banners/c17.png"/>
      <div className="pb-120 border-bottom"></div>
      <AboutArea className="bg-f3f3f3 border-bottom" />
      <TeamArea data={teamData.slice(0, 4)} titleShown={true} />
      <ContactArea className="border-top-0"/>
    </>
  );
};
 
